import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { FormActions } from '../../common/components/formControls';
import FontAwesome from 'react-fontawesome';
import ConfirmationButton from '../../common/components/ConfirmationButton';
import { withNamespaces } from 'react-i18next';

class AssessmentForm extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { title, formComponent, error, isReadonly,
			handleSubmit, onSubmit, submitting, submitSucceeded, backPath,
			enableDraft = true, enableFinal = true,
			saveDraftButtonText, saveDraftButtonIcon,
			submitFinalButtonText, submitFinalButtonIcon,
			description, showFormActionsOnTop = true, t } = this.props;
		const saveDraft = handleSubmit(values => onSubmit(values, false));	// isFinal: false
		const saveFinal = handleSubmit(values => onSubmit(values, true));	// isFinal: true

		const formActions = <FormActions horizontal labelCol={0} valueCol={12}>
			{enableFinal && <ConfirmationButton
				onConfirmation={saveFinal}
				disabled={isReadonly || submitting} bsStyle='primary' className='pull-right btn-block-xxs'
				confirmationTitle={t('FO_AssessmentForm_SaveFinal_Confirm')}
				confirmationMessage={t('FO_AssessmentForm_SaveFinal_ConfirmMessage')}>
				{submitFinalButtonText || t('FO_AssessmentForm_SaveFinal')} {submitFinalButtonIcon || <FontAwesome name='check' />}
			</ConfirmationButton>}
			{enableDraft && <Button onClick={saveDraft} disabled={isReadonly || submitting} bsStyle='primary' className='pull-right btn-block-xxs'>
				{saveDraftButtonText || t('FO_AssessmentForm_SaveDraft')} {saveDraftButtonIcon || <FontAwesome name='edit' />}
			</Button>}
			{backPath && <Link to={backPath} className='btn btn-back btn-block-xxs'><FontAwesome name='arrow-circle-left' /> {t('Common_Back')}</Link>}
		</FormActions>;

		return <div>
			<h4>{title}</h4>
			<div className='info-message' style={{ marginBottom: 10 }}>{description}</div>
			<Form horizontal>
				{error && <Alert bsStyle='danger'>{error}</Alert>}
				{submitSucceeded && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
				{showFormActionsOnTop && formActions}
				{formComponent}
				{formActions}
			</Form>
		</div>;
	}
}

export default reduxForm({ form: 'customForm', enableReinitialize: true })(withNamespaces()(AssessmentForm));
